import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalHeader,
  Input,
  Button,
  FormLabel,
  Flex,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import "./RequestPeer.scss";
import { getSectorObservations } from "../../actions/sector/sectorActions";
import Loader from "../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RoundedDotIcon from "../Icons/RoundedDotIcon";
import ViewIcon from "../Icons/ViewIcon";
import { getPeerRequest, peerRequest } from "../../actions/user/userActions";
import { toast } from "react-toastify";
import InfoIcon from "../Icons/InfoIcon";

export default function RequestPeer(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    companyName: "",
    companyWebsite: "",
    companyLinkedinURL: "",
  });

  const { loading: peerRequestLoading, data: peerRequestData } = useSelector(
    (state) => state.peerRequestReducer
  );

  useEffect(() => {
    if (props.modelRequestPeer) dispatch(getPeerRequest());
    setFormData({
      companyName: "",
      companyWebsite: "",
      companyLinkedinURL: "",
    });
  }, [props.modelRequestPeer]);

  useEffect(() => {
  if (props.modelRequestPeer) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [props.modelRequestPeer]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Updated Profile Data:", formData);
    dispatch(peerRequest(formData));
    props.setModelRequestPeer(false);
  };

  useEffect(() => {
    if (!peerRequestLoading && peerRequestData) {
      toast.success(peerRequestData.message, {
        toastId: "peerRequest",
        position: "bottom-center",
      });
    }
  }, [peerRequestLoading]);

return (
  <>
    
    {props.modelRequestPeer && (
      <Box
      className="blur-panel-content"
        position="fixed"
        top="20"
        right="0"
        height="100vh"
        width="379px" 
        backdropFilter="blur(8px)"
        background="rgba(255, 255, 255, 0.2)"
        zIndex="1400"
        pointerEvents="none" 
      />
    )}

 
    {props.modelRequestPeer && (
      <Box
      className="request-peer-modal"
        position="fixed"
        top="10"
        right="0"
        height="200vh"
        width={{ base: "100%", md: "400px" }}
        zIndex="1500"
        backgroundColor="white"
        boxShadow="lg"
        overflowY="auto"
        p={6}
      >
        {/* Header */}
        <Flex justifyContent="space-between" alignItems="center" mb={4}>
          <Text fontSize="xl" fontWeight="bold">
            Request For Peer
          </Text>
          <Button
            onClick={() => props.setModelRequestPeer(false)}
            variant="ghost"
            fontSize="lg"
            lineHeight="1"
          >
            ✕
          </Button>
        </Flex>

        {/* Pending Requests */}
        <Box backgroundColor="#E6E6E6" borderRadius="4px" mb={5}>
          <Flex padding="5px">
            <Box padding="4px">
              <RoundedDotIcon />
            </Box>
            <Text className="heading-label">Pending requests</Text>
          </Flex>
          {peerRequestLoading ? (
            <Loader />
          ) : (
            <Box flexWrap="wrap" padding="5px" mb={4}>
              {peerRequestData &&
                peerRequestData.map((peerRequest, idx) => (
                  <Flex
                    key={idx}
                    className="peer-block"
                    justifyContent="space-between"
                    alignItems="center"
                    py={1}
                  >
                    <Box fontSize="14px">
                      {`${String(idx + 1).padStart(2, "0")}. ${peerRequest?.companyName}`}
                    </Box>
                    <Box ml="10px" cursor="pointer">
                      <ViewIcon />
                    </Box>
                  </Flex>
                ))}
            </Box>
          )}
        </Box>

        {/* Form */}
        <form onSubmit={handleSubmit} className="profile-form">
          <Box mb={4}>
            <FormLabel fontSize="13px"  mb={1}>
              Organization Name
            </FormLabel>
            <Input
              type="text"
              name="companyName"
              placeholder="Organization Name"
              value={formData.companyName}
              onChange={handleChange}
            />
          </Box>

          <Box mb={4}>
            <FormLabel fontSize="13px"  mb={1}>
              Website
            </FormLabel>
            <Input
              type="text"
              name="companyWebsite"
              placeholder="Website"
              value={formData.companyWebsite}
              onChange={handleChange}
            />
          </Box>

          <Box mb={4}>
            <FormLabel fontSize="13px"  mb={1}>
              LinkedIn URL
            </FormLabel>
            <Input
              type="text"
              name="companyLinkedinURL"
              placeholder="LinkedIn URL"
              value={formData.companyLinkedinURL}
              onChange={handleChange}
            />
          </Box>

          {/* Info Note + Submit */}
          <Box mb={4} textAlign="center">
            <Flex justifyContent="center" mb={3}>
              <Flex
                p="5px"
                bgColor="#ADECFF"
                borderRadius="4px"
                alignItems="center"
              >
                <Box pr="2px">
                  <InfoIcon />
                </Box>
                <Text fontSize="13px" fontWeight={500}>
                  Requests are processed within 7 - 15 days
                </Text>
              </Flex>
            </Flex>
            <Button type="submit" className="save-btn" width="100%">
              Submit Request
            </Button>
          </Box>
        </form>
      </Box>
    )}
  </>
);



}